import { taskAxiosInstance } from "../axiosInstance";

export type TaskAccessLevel = "CONTRIBUTOR" | "READER";

export interface TaskAccess {
    instanceId: number;
    productInstanceId: number;
    customerName: string;
    productInstanceName: string;
    accessLevel: TaskAccessLevel;
}

export interface TaskAbilityRule {
    action: string | string[];
    subject: string | string[];
    conditions?: Record<string, unknown>;
    fields?: string | string[];
    inverted?: boolean;
    reason?: string;
}

export interface TaskAbilityResponse {
    rules: TaskAbilityRule[];
}

export interface TaskAccessQuery {
    userId?: number;
    customerId?: number;
}

export const getTaskAccess = async (query: TaskAccessQuery = {}): Promise<TaskAccess[]> => {
    const response = await taskAxiosInstance.get<TaskAccess[]>("/auth", {
        params: query,
    });

    return response.data;
};

export const getTaskAbility = async (): Promise<TaskAbilityResponse> => {
    const response = await taskAxiosInstance.get<TaskAbilityResponse>("/auth/ability");

    return response.data;
};
